import { useTranslation } from 'react-i18next'
import type { Outcome } from '@brochure/shared'
import { formatLine, outcomeText } from '@/lib/stockbet'

/** Etichetta di un esito ("Casa −1,5", "Over 2,5", "Ugo"): la stessa sui mercati, in schedina e nelle schedine giocate. */
export function useOutcomeLabel() {
  const { t, i18n } = useTranslation()
  return (o: Outcome, names: Record<string, string>) => {
    const { key, values } = outcomeText(o, names)
    const line = typeof values.line === 'number' ? formatLine(values.line, i18n.language, o.market === 'handicap') : undefined
    // Spazio a larghezza zero dopo la barra: "Lorenzo/Francesco" va a capo dopo "/" e non a metà nome.
    return t(key, { ...values, ...(line !== undefined && { line }) }).replace(/\//g, '/​')
  }
}
